<template>
  <div class="sidebar">
      <transition name="slide-right">
        <div class="sidebar__menu" v-show="menu">
          <transition>
          <div class="sidebar__panel--tags inner" v-if="panel === 'tags'" key="tags">
            <button class="btn--close--white" @click="togglePanel(panel)"><span class="icon-tick"></span> Done</button>

          </div>
          <div class="sidebar__panel--contact inner" v-else-if="panel === 'contact'" key="contact">
            <button class="btn--close--white" @click="togglePanel(panel)"><span class="icon-close"></span> Close</button>
          </div>
          <div class="sidebar__panel--info inner" v-else-if="panel === 'info'" key="info">
            <button class="btn--close--white" @click="togglePanel(panel)"><span class="icon-close"></span> Close</button>
          </div>
          </transition>
        </div>
      </transition>
      <div class="sidebar__nav">
        <h1 class="logo">
          Northern Take
        </h1>
        <nav class="nav--main">
          <ul>
              <!--
            <li><button class="btn" @click="togglePanel('tags')" :class="{active : panel === 'tags' && menu}"><span class="icon-tag"></span></button></li>
            <li><button class="btn" @click="togglePanel('contact')" :class="{active : panel === 'contact' && menu}"><span class="icon-bubble"></span></button></li>
            <li><button class="btn" @click="togglePanel('info')" :class="{active : panel === 'info' && menu}"><span class="icon-i"></span></button></li>
                -->
          </ul>
        </nav>
      </div>
  </div>
</template>

<script>
export default {
  name: 'sidebar',
  data () {
    return {
      panel: false,
      menu: false
    }
  },
  methods: {
    togglePanel: function (panel) {
      var menu = this.menu
      if (this.panel === panel && !this.menu) {
        this.panel = panel
        this.menu = true
      } else {
        this.menu = this.panel === panel ? this.menu = false : this.menu = true
        this.panel = panel
      }

      if (menu !== this.menu) {
        this.$emit('menu')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

// ============================
// Imports
// ============================

@import '../sass/variables.scss';
@import '../sass/reset/nav';
@import '../sass/reset/button';

// ++++++++++++++++++++++++++++

/**
 * Sidebar
 */
.sidebar {
  display:flex;
  position:fixed;
  height:100%;
  left:0;
  top:0;
  z-index: 999999;
  color:white;

  .sidebar__menu {
    width: 31.25em; /* 500/16 */
    background-color: $brand-primary;
    overflow:hidden;
    position: relative;
  }

  /**
   * Sidebar Panel
   */
  .sidebar__panel {
    width: 26.25em; /* 420/16 */
    background-color: $brand-primary;
    position:absolute;
    padding:0 2.5em; /* 20/16 */ /* 40/16 */
  }

  .sidebar__panel--tags {
      @extend .sidebar__panel;
  }

  .sidebar__panel--contact {
      @extend .sidebar__panel;
  }

  .sidebar__panel--info {
      @extend .sidebar__panel;
  }

  /**
   * Sidebar Nav
   */
  .sidebar__nav {
    width:3.625em; /* 90/16 */
    display:flex;
    flex-direction:column;

    .logo {
      padding: 0.75em 0.625em 0.6em 0.625em;
      transform: rotate(-90deg) translateX(-11.8em) translateY(2.4em);
      transform-origin: 0 100%;
      background-color: $brand-primary;
      white-space: nowrap;
      font-size: 1.5em; /* 24/16 */
      width: 10em; /* 160/16 */
      font-weight: 300;
      letter-spacing: 0.0625em; /* 1/16 */
      text-align: center;
      margin:0;
      font-family: 'Oxygen', Helvetica, Arial, sans-serif;
      //border-bottom: 3px solid darken($brand-primary,10%);
      border-radius: 0 0 0.1875em 0.1875em; /* 3/16 */ /* 3/16 */

      @media screen and (max-width: 756px) {
        font-size: 1em;
      }
    }

    .nav--main {
      margin-top:20em;
      @extend .nav;

      li {
        margin-bottom: 0.5em; /* 20/16 */
      }

      button {
        border-radius: 0 3px 3px 0;
        padding: 0.625em; /* 10/16 */
        width:100%;
        text-align: center;
        font-size: 1.5em;

        &.active {
          background-color: $brand-primary;
          color: white;
        }
      }
    }

  }

}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?77e20693